import { render, staticRenderFns } from "./GAuthTextUnderlineForm.vue?vue&type=template&id=2a34d03e&"
import script from "./GAuthTextUnderlineForm.vue?vue&type=script&lang=ts&"
export * from "./GAuthTextUnderlineForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports